import { any } from "bluebird";
import React from "react";
import {
    ButtonToolbar,
    Button,
    Modal,
    FormGroup,
    ControlLabel,
    FormControl,
} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import axios from 'axios';
import { host } from '../../../config';
import { BootstrapTable } from "react-bootstrap-table";
import { Tabs, Tab } from 'react-bootstrap';
import NotificationSystem from 'react-notification-system';
import TextEditor from "./TextEditor";
import { Right } from "react-bootstrap/lib/Media";
import UploadFormModal from "./UploadFormModal ";
import { fetchBidsets } from "../../../core/api";
import { checkHttpStatus, parseJSON } from "../../../utils";
import DraftRenderer from "../../../components/DraftRenderer/DraftRenderer";

function findById(value) {
    console.log('findById ', value.id, this);
    return value.id === Number(this);
}


function formatNotes(notes) {
    const noteList = [];
    noteList.push(
        <div className="note">
            <DraftRenderer raw={notes} />
        </div>
        );
    return noteList;
}

class DefineGroupPopup extends React.Component {
    constructor(props) {
        super(props);
        let subgroupdetails = [{
            roomType: "Choose Room Types",
            numberOfRooms: '',
            groupId: 0,
            tourId: 0
        }]

        this.state = {
            definebidpopup: false,
            numSubGroups: 0,
            subGroupNames: Array(5).fill(''),
            additionalQuestion: [], // Placeholder for additional questions
            newQuestion: '', // New question input value
            // Add other necessary states for handling additional questions and bid notes
            disabled: false,
            inputVal: '',
            btndis: false,
            question: null,
            countClick: 0,
            noOfQuestion: 0,
            sendPayload: [],
            groupdata: [],
            isCollapsed: {},
            showConfirmDialog: false,
            groupId: 0,
            editdata: [],
            editTablepopup: false,
            subgroupdetails,
            notificationSystem: null,
            notesGroup: [],
            uploadDocModel:false,
            groupDocId:0,
            eventIds:[],
            uploadedDocuments:[],
            bidSetData:[],
            bidSetflag:false,
            deleteBtnflag:false
        };

        this.defineBidPopup = this.defineBidPopup.bind(this);
        this.createQuestions = this.props.createQuestions.bind(this); // Assuming these methods come from props
        this.removeQuestion = this.props.removeQuestion.bind(this); // Assuming these methods come from props
        this.removeGroupAction = this.removeGroupAction.bind(this);
    }

    defineBidPopup() {
        this.setState({
            definebidpopup: true,
        });
    }
    componentDidMount() {
        this.setState({
            notificationSystem: this.refs.notificationSystem
        });
    }

    componentWillMount() {
        const data = this.props.tour.groups
        const roomInformation = this.props.tour.room_information
        const tempRoomInformation = roomInformation.map((item) => ({
            roomType: item.room_type,
            numberOfRooms: item.no_of_rooms,
            groupId: item.group_id,
            tourId: item.tour_id
        }))
        this.setState({
            subgroupdetails: [...tempRoomInformation],

        });
        const gropdata = this.groupDataByName(data)
        this.setState({ groupdata: gropdata });
    }
    componentWillReceiveProps() {
        const data = this.props.tour.groups
        const temparr = []
        const tempgroup = []
        data.forEach((itm) => {
            if (Array.isArray(itm)) {
                // If itm is a list (array), iterate through its elements
                itm.forEach((element) => {
                    tempgroup.push({
                        roomType: 'Suite',
                        numberOfRooms: '',
                        groupId: element.id,
                        tourId: element.tour
                    })
                    temparr.push(element);
                });

            } else {
                // If itm is not a list, push the object directly to temparr
                temparr.push(itm);
            }
        });
        const { groupdata } = this.state
        if (groupdata.length !== data.length) {
            const gropdata = this.groupDataByName(temparr)
            this.setState({ groupdata: gropdata });
            if (tempgroup.length > 0) {
                this.setState({
                    subgroupdetails: [...this.state.subgroupdetails, ...tempgroup],

                });
            }
        }
    }

    groupDataByName = (data) => {
        const groupedData = {
            groupName: '',
            groupId: ''
        }
        const groupDataList = data.map((tempval) => (
            {
                group_name: tempval.name,
                group_id: tempval.id,
            }
        ))


        return groupDataList
    };

    showNotification = (level, message) => {
        if (this.state.notificationSystem) {
            this.state.notificationSystem.addNotification({
                message: message,
                level: level,
                autoDismiss: 8 // Auto-dismiss the notification after 5 seconds
            });
        }
    };


    onClosebidpopup = () => {
        this.setState({
            sendPayload: [],
            definebidpopup: false,
            editTablepopup: false,
            showConfirmDialog: false,
            numSubGroups: 0,
            bidSetflag:false,
            deleteBtnflag:false
        });
    };

    handleSubGroupNameChange = (index, e) => {
        const { subGroupNames } = this.state;
        const updatedSubGroupNames = [...subGroupNames];
        updatedSubGroupNames[index] = e.target.value;
        this.setState({
            subGroupNames: updatedSubGroupNames,
        });
    };


    handleAddQuestion = () => {
        var input = <input id='inputField' type="text" placeholder="Enter Question" className="form-control" onChange={(e) => this.extraQuestions(e)} />;
        this.setState({
            inputVal: input,
            btndis: true
        })
    }

    extraQuestions = (e) => {
        var ques = e.target.value;
        if (ques == '') {
            this.setState({
                btndis: true,
            })
        } else {
            this.setState({
                question: ques,
                btndis: false,
            })
        }
    }

    AddQuestions = (index) => {
        const value = 10;
        if (this.state.countClick < value) {
            let counter = this.state.countClick + 1;
            let number_question = this.state.noOfQuestion + 1
            let question = this.state.question;
            var payload = { question: question, question_field_type: 'TE', question_number: number_question, hide: false, is_default: false, tour_id: this.props.tour.id, group_id: index }
            this.props.createQuestions(payload, (response) => {
                if (this.props.addedQuestion) {
                    let quesVal = this.props.addedQuestion.questions;
                    let addQuest = this.state.additionalQuestion;
                    addQuest.push(quesVal)
                    this.setState({
                        countClick: counter,
                        additionalQuestion: addQuest,
                        noOfQuestion: number_question,
                    })
                } else {
                    console.log("Data is not avaiable")
                }
            })
            // document.getElementById("inputField").innerText = "";
            // document.getElementById("inputField").value = "";
            this.setState({
                btndis: true,
                inputVal: false
            })
            document.getElementById("inputField").value = "";
        } else {
            alert("You can add only 'Ten' questions.")
            this.setState({
                inputVal: false,
            })
        }
    }
    clearQuestions = (value) => {
        let id = value.id;
        let group_id = value.group_id;
        this.props.removeQuestion(id, (response) => {
            this.props.requestTourquestions(group_id, (response) => {
                if (this.props.addQuestion.questions) {
                    let addQuest = [];
                    this.props.addQuestion.questions.forEach((question) => {
                        if (question.group_id == group_id) {
                            addQuest.push({
                                id: question.id,
                                question: question.question,
                                question_field_type: question.question_field_type,
                                sort_order: question.sort_order,
                                hide: question.hide,
                                is_default: question.is_default,
                                tour_id: question.tour_id,
                                group_id: question.group_id
                            })
                        }
                    })
                    this.setState({
                        additionalQuestion: addQuest,
                        countClick: this.props.addQuestion.questions.length,
                        noOfQuestion: this.props.addQuestion.questions.length,

                    })
                } else {
                    console.log("data is not avaiable")
                }
            });
        });
    }

    handleNumSubGroupsChange = (e) => {
        const number = parseInt(e.target.value, 10);
        let sendPayload = [...this.state.sendPayload]; // Copy the existing payload

        if (number > this.state.numSubGroups) {
            const details = {
                tourId: this.props.tour.id,
                subgroupName: "",
                roomType: "Choose Room Types",
                noOfRooms: "",
                groups: "",
            };
            const additionalRows = Array.from({ length: number - this.state.numSubGroups }, (_, index) => ({
                Sno: sendPayload.length + index + 1,
                ...details
            }));
            sendPayload = sendPayload.concat(additionalRows);
        } else if (number < this.state.numSubGroups) {
            sendPayload = sendPayload.slice(0, number); // Remove rows from the end if the new count is less
        }

        this.setState({ numSubGroups: number, sendPayload });
    };

    handleCellEdit = (rowIndex, column, value) => {
        const { sendPayload } = this.state;
        const updatedPayload = sendPayload.map((item, index) => {
            if (index === rowIndex) {
                return { ...item, [column]: value };
            }
            return item;
        });

        this.setState({ sendPayload: updatedPayload });
    };

    deleteGroup(id) {
        this.setState({
            deleteBtnflag:true,
            showConfirmDialog: true,
            groupId: id,
        })
        const data=fetchBidsets(this.props.tour.id)
        data.then(checkHttpStatus).then(parseJSON).then((response) => {
        this.setState({
            bidSetData:response,
        })
        })
    }
    editGroup(data) {
        const tempEditData = []
        tempEditData.push(data)
        this.setState({
            editdata: tempEditData,
            editTablepopup: true
        })
    }

    findGroup(id) {
        const idx = this.props.tour.groups.findIndex(findById, id);
        if (idx === -1) {
            return {};
        }
        return this.props.tour.groups[idx];
    }
    handleAddRow = (groupid) => {
        const tour_id = this.props.tour.id
        const { subgroupdetails } = this.state;
        const emptyRow = {
            roomType: 'Choose Room Types',
            numberOfRooms: '',
            groupId: groupid,
            tourId: tour_id
        };

        // Add the new empty row to the state
        this.setState({
            subgroupdetails: [...subgroupdetails, emptyRow],
        });
    };

    removeGroupAction() {
        const id = (this.state.groupId) ? this.state.groupId : 0;
        const bidSetValue= this.state.bidSetData.results.filter((item)=>{
            if(item.tourgroup_id === id){
                return item
            }
        })
        if (bidSetValue.length > 0){
            this.setState({
                bidSetflag:true
            })
        }
        else{
            if (id) {
            this.props.removeGroup(this.findGroup(id));
            this.setState({ showConfirmDialog: false, groupId: 0,deleteBtnflag:false });
        }
        }
    }
    removeConfirmBid=()=>{
        const id = (this.state.groupId) ? this.state.groupId : 0;
        this.props.removeGroup(this.findGroup(id));
        this.setState({ showConfirmDialog: false, groupId: 0,bidSetflag:false,deleteBtnflag:false });
    }
    submitGroupData = () => {
        const groupedPayload = {};
        let sendGroupFlag = false
        this.state.sendPayload.forEach((item) => {
            const { Sno, subgroupName, roomType, noOfRooms, tourId } = item;
            if (subgroupName.length === 0) {
                sendGroupFlag = true
            }

            if (!groupedPayload[subgroupName]) {
                groupedPayload[subgroupName] = {
                    groupName: subgroupName,
                    tourId: tourId,
                    // roomInformation: []
                };
            }

        });

        const updatedPayload = Object.values(groupedPayload);
        if (!sendGroupFlag) {
            const data = this.props.newGroup(updatedPayload);
        }
        this.setState({
            sendPayload: [],
            definebidpopup: false,
            numSubGroups: 0
        })
    };

    sendEditGroup = () => {
        const { editdata } = this.state;
        const tempPayload = {};
        const { group_id, group_name } = editdata[0]
        tempPayload['name'] = group_name
        this.props.editGroup(group_id, tempPayload);
        this.setState({
            editTablepopup: false,
        })

    };
    submitRowData = (e,groupid, groupName) => {
        e.currentTarget.disabled=true
        const tempval = this.state.subgroupdetails.filter(row => row.groupId === groupid)
        this.props.newRoomType(tempval, (response) => {
        })
        const group_id = tempval[0].groupId
        Promise.all([
            this.fetchBidValue(group_id, 0),
        ])
            .then(([bidValueResponse]) => {
                this.showBidData(bidValueResponse.data, tempval, groupName);
                e.currentTarget.disabled = false;
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                this.setState({ isLoading: false });
            });

    }
    fetchBidValue = (group_id, event_id) => {
        const tokenKey = JSON.parse(sessionStorage.getItem('auth')).token;
        return axios.get(`${host}/api/bidvalue/get_bid_value/?group_id=${group_id}&event_id=${event_id}`, {
            headers: {
                Authorization: `Token ${tokenKey}`,
            },
        });
    }

    showBidData(bid_details, tempval, groupName) {
        const tourIdStore = this.props.tour.tour_stops
        for (let i = 0; i < tourIdStore.length; i++) {
            const { related_group_events } = tourIdStore[i]
            for (let i = 0; i < related_group_events.length; i++) {
                const event_id = related_group_events[i].id
                const group = related_group_events[i].group_name
                let payloaddummy = [];
                let counter = 0
                for (let i = 0; i < tempval.length; i++) {
                    const formData = tempval[i]

                    if (formData.roomType === 'Choose Room Types' || group !== groupName) {
                        continue
                    }
                    const totalRoomsForFormData = formData.numberOfRooms;
                    const roomType = formData.roomType === 'Suite' ? 'Suite' : formData.roomType === 'King' ? 'King' : formData.roomType === 'Double' ? 'Double' : '';
                    for (let j = 0; j < totalRoomsForFormData; j++) {
                        const bidData = bid_details[counter]
                        payloaddummy.push({
                            suite: formData.roomType === 'Suite',
                            king: formData.roomType === 'King',
                            double: formData.roomType === 'Double',
                            twobeds: formData.roomType === 'Two Beds',
                            Juniorsuite: formData.roomType === 'Junior Suite',
                            twobedroomsuite: formData.roomType === '2 Bedroom Suite',
                            travelprofile_id: 0,
                            event_id: event_id,
                            tour_id: formData.tourId,
                            group_id: formData.groupId,
                            room_type: formData.roomType === 'Suite' ? 1 : formData.roomType === 'King' ? 2 : formData.roomType === 'Double' ? 3 : formData.roomType === 'Two Beds' ? 4 : formData.roomType === 'Junior Suite' ? 5 : formData.roomType === '2 Bedroom Suite' ? 6 : 0,// Adjust the logic for room types as per your requirements
                            id: (() => {
                                try {
                                    return bidData.id;
                                } catch (error) {
                                    console.error("Error while fetching bidData.id:", error);
                                    return 0;
                                }
                            })()
                        });
                        counter = counter + 1
                    }
                }
                if (payloaddummy.length > 0) {
                    this.props.addMultipleBidDetail(payloaddummy, 0, (response) => {

                    })
                }
            }
        }
        this.showNotification('success', ' Room type added successfully!!');

    }
    onSubmit = (values,form) => {
        this.props.saveRoomPreferences(values.group, values);
        form.reset();
        
    }

    // toggleCollapse = (index, group_id) => {
    //     const { groups } = this.props.tour;

    //     // Close all collapses
    //     const updatedCollapseState = {};
    //     Object.keys(this.state.isCollapsed).forEach((key) => {
    //         updatedCollapseState[key] = false;
    //     });

    //     // Toggle the collapse of the clicked item
    //     updatedCollapseState[index] = !this.state.isCollapsed[index];

    //     this.setState({
    //         isCollapsed: updatedCollapseState
    //     });

    //     const value = groups.find(d => d.id === group_id);
    //     this.setState({
    //         notesGroup: value
    //     });

    //     let additionalQuest = [];
    //     this.props.requestTourquestions(group_id, (response) => {
    //         if (this.props.addQuestion.questions) {
    //             this.props.addQuestion.questions.forEach((question) => {
    //                 if (question.group_id == group_id) {
    //                     additionalQuest.push({
    //                         id: question.id,
    //                         question: question.question,
    //                         question_field_type: question.question_field_type,
    //                         sort_order: question.sort_order,
    //                         hide: question.hide,
    //                         is_default: question.is_default,
    //                         tour_id: question.tour_id,
    //                         group_id: question.group_id
    //                     });
    //                 }
    //             });
    //             this.setState({
    //                 additionalQuestion: additionalQuest,
    //                 countClick: this.props.addQuestion.questions.length,
    //                 noOfQuestion: this.props.addQuestion.questions.length,
    //             });
    //         } else {
    //             console.log("Data is not available");
    //         }
    //     });
    // };

    toggleCollapse = (index, group_id) => {
        const { groups,tour_stops } = this.props.tour;
        let eventIdsTemp=[]
        tour_stops.map((data)=>{
            eventIdsTemp.push(data.id)
        })
        this.setState({
            eventIds:eventIdsTemp,
            groupDocId:group_id
        },()=>{
            this.fetchDocuments(this.state.eventIds,this.state.groupDocId,this.props.tour.id)
        })

        // Close all collapses
        const updatedCollapseState = {};
        Object.keys(this.state.isCollapsed).forEach((key) => {
            updatedCollapseState[key] = false;
        });

        // Toggle the collapse of the clicked item
        updatedCollapseState[index] = !this.state.isCollapsed[index];

        this.setState((prevState) => ({
            isCollapsed: { ...prevState.isCollapsed, ...updatedCollapseState },
            notesGroup: groups.find(d => d.id === group_id),
        }));

        let additionalQuest = [];
        this.props.requestTourquestions(group_id, (response) => {
            if (this.props.addQuestion.questions) {
                this.props.addQuestion.questions.forEach((question) => {
                    if (question.group_id === group_id) {
                        additionalQuest.push({
                            id: question.id,
                            question: question.question,
                            question_field_type: question.question_field_type,
                            sort_order: question.sort_order,
                            hide: question.hide,
                            is_default: question.is_default,
                            tour_id: question.tour_id,
                            group_id: question.group_id,
                        });
                    }
                });
                this.setState({
                    inputVal: false,
                    additionalQuestion: additionalQuest,
                    countClick: this.props.addQuestion.questions.length,
                    noOfQuestion: this.props.addQuestion.questions.length,
                });
            } else {
                console.log("Data is not available");
            }
        });
    };

    fetchDocuments = (eventId,groupId,tourId) => {
        const auth = JSON.parse(sessionStorage.getItem('auth'));
        const tokenKey = auth.token;
        const upload_type = 'Bid Group'
        axios.get(`${host}/api/participants_documents/get_documents_by_tour/?tour_id=${tourId}&upload_type=${upload_type}&event_id=${eventId}&group_id=${groupId}&bid_id=${null}`, {
            headers: {
                Authorization: `Token ${tokenKey}`,
            },
        })
            .then((response) => {
                const groupedDocuments = {};
                response.data.forEach((document) => {
                    const documentKey = `${document.document_name}+${document.document_type}+${document.uploaded_by}+${document.upload_type}`;
                    if (!groupedDocuments[documentKey]) {
                        // Create a new group for the unique document
                        groupedDocuments[documentKey] = {
                            bidIds: [],
                            upload_date:[]
                        };
                    }
                    // Store document id and bid id in arrays
                    groupedDocuments[documentKey].bidIds.push(document.id);
                    groupedDocuments[documentKey].upload_date.push(document.upload_date)
                });
        
                // Convert groupedDocuments object to an array of objects
                const uniqueDocuments = Object.entries(groupedDocuments).map(([key, value]) => ({
                    document_name: key.split('+')[0],
                    document_type: key.split('+')[1],
                    uploaded_by: key.split('+')[2],
                    upload_type:key.split('+')[3],
                    upload_date:value.upload_date[0],
                    id: value.bidIds
                }));
        
                this.setState({ uploadedDocuments: uniqueDocuments });
            })
            .catch((error) => {
                console.error('Error fetching documents:', error);
            });
    };
    
    openUploadDocument=()=>{
        this.setState({ uploadDocModel:true })
      }
    
    closeModal=()=>{
    this.setState({ uploadDocModel:false })
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        console.log('name', name)
        console.log('value', value)
    }
    hadleRoomTypeIcon = (cell, row) => {
        return `${cell} <i class="fa fa-sort-desc roomtype-arrow" aria-hidden="true"></i>`
    }

    render() {
        const selectRoomTypeOptions = ['Suite', 'King', 'Double', 'Two Beds', 'Junior Suite', '2 Bedroom Suite'];
        const { numSubGroups, subGroupNames, groupdata, definebidpopup, subgroupdetails,notesGroup } = this.state;
        const { room_information, groups } = this.props.tour
        // Generate options for the dropdown with numbers 1 to 5
        const options = [];
        for (let i = 0; i <= 5; i++) {
            options.push(<option key={i} value={i}>{i}</option>);
        }
        if (!groupdata) {
            return (
                <div>
                    {/* Display the "Define Group" button */}
                    <ButtonToolbar>
                        <Button bsStyle="success" onClick={this.defineBidPopup}>
                            <i className="fa fa-group" /> Define Groups
                        </Button>
                    </ButtonToolbar>
                    <div>Loading...</div>
                </div>
            );
        }
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <ButtonToolbar>
                    <Button bsStyle="success" onClick={this.defineBidPopup}>
                        <i className="fa fa-group" /> Define Groups
                    </Button>
                </ButtonToolbar>
                {definebidpopup && (
                    <Modal show={definebidpopup} onHide={this.onClosebidpopup}>
                        <Modal.Header closeButton>
                            <Modal.Title>Define Group</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormGroup style={{ display: 'flex' }} >
                                <ControlLabel style={{ marginTop: '2px' }} >How many Sub-Groups?</ControlLabel>
                                <FormControl
                                    componentClass="select"
                                    onChange={this.handleNumSubGroupsChange}
                                    value={this.state.numSubGroups}
                                    style={{ width: '5%', marginLeft: '10px', border: '1px solid', height: '26px' }}
                                >
                                    {options}
                                </FormControl>
                            </FormGroup>
                            <BootstrapTable
                                data={this.state.sendPayload}
                                striped
                                cellEdit={{
                                    mode: 'click',
                                    blurToSave: true,
                                    afterSaveCell: (oldValue, newValue, row, column) => this.handleCellEdit(row, column, newValue)
                                }}
                            >
                                <TableHeaderColumn dataField="id" width="100" hidden isKey>ID</TableHeaderColumn>
                                <TableHeaderColumn dataField="Sno" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >Sub-group#</TableHeaderColumn>
                                <TableHeaderColumn dataField="subgroupName" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >Sub group name</TableHeaderColumn>
                                {/* <TableHeaderColumn dataField="roomType" width="100" headerAlign="center" dataAlign="center"
                                        editable={{
                                            type: 'select',
                                            options: { values: selectRoomTypeOptions },
                                            validator: (value) => value !== ''
                                        }}
                                    >
                                        Room Type
                                    </TableHeaderColumn>
                                    <TableHeaderColumn dataField="noOfRooms" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >No of rooms</TableHeaderColumn> */}
                                {/* <TableHeaderColumn dataField="groups" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >Group</TableHeaderColumn> */}
                            </BootstrapTable>
                            <br></br>
                            <div className="row">
                                <div className="col-md-12">
                                    <FormGroup>
                                        <ButtonToolbar>
                                            <Button bsStyle="success" onClick={this.submitGroupData}>
                                                Save
                                            </Button>
                                            <Button bsStyle="success" onClick={this.onClosebidpopup}>
                                                Cancel
                                            </Button>
                                        </ButtonToolbar>
                                    </FormGroup>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer style={{ clear: 'both' }} />
                    </Modal>
                )}
                <br></br>
                <div>
                    {groupdata.map((dataItem, index) => (
                        <div key={index} className={this.state.subgroupdetails.length > 0 ? "group-no-data" : "group-data"}>
                            <div style={{ display: 'flex' }}>
                                <h3>{dataItem.group_name}</h3>
                                <div>
                                    <Button bsStyle="success" style={{ marginLeft: '15px', marginBottom: '5px' }} onClick={() => this.editGroup(dataItem)}>
                                        Edit
                                    </Button>
                                    <Button disabled={this.state.deleteBtnflag} bsStyle="danger" style={{ marginLeft: '5px', marginBottom: '5px' }} onClick={() => this.deleteGroup(dataItem.group_id)}>
                                        Delete
                                    </Button>
                                </div>
                            </div>
                            <div className={this.state.subgroupdetails.length > 0 ? "inner-group-no-data" : "inner-group-data"}>
                                {this.state.subgroupdetails.filter(row => row.groupId === dataItem.group_id).length > 0 && (
                                    <BootstrapTable
                                        key={index}
                                        data={this.state.subgroupdetails.filter(row => row.groupId === dataItem.group_id)}
                                        striped
                                        cellEdit={{
                                            mode: 'click',
                                            blurToSave: true,
                                            afterSaveCell: (oldValue, newValue, row, column) => this.handleCellEdit(row, column, newValue)
                                        }}
                                    >
                                        <TableHeaderColumn dataField="id" width="100" hidden isKey>ID</TableHeaderColumn>
                                        <TableHeaderColumn dataField="roomType" dataFormat={this.hadleRoomTypeIcon} width="150" headerAlign="center" dataAlign="center"
                                            editable={{
                                                type: 'select',
                                                options: { values: selectRoomTypeOptions },
                                                validator: (value) => value !== ''
                                            }}
                                        >
                                            Room Type
                                        </TableHeaderColumn>
                                        <TableHeaderColumn dataField="numberOfRooms" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }}>No of rooms</TableHeaderColumn>
                                    </BootstrapTable>
                                )}
                                {this.state.subgroupdetails.filter(row => row.groupId === dataItem.group_id).length === 0 && (
                                    <div style={{ textAlign: 'center', marginTop: '10px' }}>Click Add button to choose room type</div>
                                )}
                                {/* Conditional rendering of buttons */}
                                {room_information.filter(row => row.group_id === dataItem.group_id).length > 0 ? (
                                    <div style={{ textAlign: 'center', marginTop: '10px' }}></div>
                                ) : (
                                    <div>
                                        <Button bsStyle="success btn-sm" style={{ width: '10%', float: 'right', marginLeft: '12px' }} onClick={(e) => this.submitRowData(e,dataItem.group_id, dataItem.group_name)} >Save</Button>
                                        <Button bsStyle="success btn-sm" style={{ width: '10%', float: 'right' }} onClick={() => this.handleAddRow(dataItem.group_id)}>Add</Button>
                                    </div>
                                )}
                            </div>
                            <div className={this.state.subgroupdetails.length > 0 ? "inner-group-no-data" : "inner-group-data"}>
                                <Button
                                    key={`collapseBtn-${index}`}
                                    onClick={() => this.toggleCollapse(index, dataItem.group_id)}
                                    bsStyle="success"
                                    aria-controls={`additionalContent-${index}`}
                                    aria-expanded={!this.state.isCollapsed[index]}
                                    style={{ width: '100%', marginBottom: '12px', marginTop:"5px", outline: 'None' }}
                                >
                                    <i className={`${this.state.isCollapsed[index] ? 'fa fa-arrow-up' : 'fa fa-arrow-down'}`} aria-hidden="true" />  Question & Notes
                                </Button>
                                <div className={`collapse ${this.state.isCollapsed[index] ? 'show' : ''}`} id={`additionalContent-${index}`}>
                                    <div className={this.state.subgroupdetails.length > 0 ? "inner-group-no-data" : "inner-group-data"} >
                                        <h4><b>Additional Questions</b> <small style={{ color: "red" }}>(Add up to 10 questions)</small></h4>
                                        <ol type='1'>
                                            {this.state.additionalQuestion.map((value, index) => (
                                                <div key={index}>
                                                    {value.question ? (
                                                        <div className="row margin-top-5">
                                                            <li>
                                                                <div className="col-md-9"><h4>{value.question}</h4></div>
                                                                <div className="col-md-2">
                                                                    <Button bsStyle="danger" onClick={() => this.clearQuestions(value)}>
                                                                        <i className="fa fa-trash" /> Clear
                                                                    </Button>
                                                                </div>
                                                            </li>
                                                        </div>
                                                    ) : ('')}
                                                </div>
                                            ))}
                                        </ol>
                                    </div>
                                    <div>
                                        <div>
                                            <Button bsStyle="success" disabled={this.state.disabled} onClick={this.handleAddQuestion}>
                                                <i className="fa fa-plus" /> Add Question
                                            </Button>
                                            &nbsp;&nbsp;
                                            {/* <Button bsStyle="success" onClick={this.openUploadDocument} > 
                                                <i className="fa fa-file-code-o" /> Add Bid Documents
                                            </Button>
                                            Click to add documents to attach to each hotel bid in every stop. */}
                                        </div>
                                        {this.state.inputVal ? (
                                            <div className="row">
                                                <div className="col-md-10">{this.state.inputVal}</div>
                                                <div className="col-md-2">
                                                    <Button bsStyle="success" disabled={this.state.btndis} onClick={() => this.AddQuestions(dataItem.group_id)}>
                                                        Add
                                                    </Button>
                                                </div>
                                            </div>
                                        ) : ('')}
                                        <br></br>
                                        <div>
                                            <h1 style={{fontSize:'18px',fontWeight:'bold'}} >Click to add documents to attach to each hotel bid in every stop.</h1> 
                                        </div>
                                        <div style={{display:'flex'}}>
                                            <Button bsStyle="success" onClick={this.openUploadDocument} > 
                                                <i className="fa fa-file-code-o" /> Hotel stay Documents
                                            </Button>
                                            <div style={{display:'flex'}} >
                                                <span>{this.state.uploadedDocuments.length>0&&<p style={{color:'green',marginLeft:'5px',marginTop:'5px'}}>Note:- Document uploaded</p>}</span>
                                                {this.state.uploadedDocuments.length>0&&(<span className="doccout" ><p>{this.state.uploadedDocuments.length}</p></span>)}
                                            </div>
                                        </div>
                                    </div><br />
                                    <h4><b>Additional Bid Notes</b></h4>
                                    <div>
                                    {notesGroup && notesGroup.hotel_prefs && notesGroup.hotel_prefs.note_json && notesGroup.hotel_prefs.note_json.blocks && formatNotes(notesGroup.hotel_prefs.note_json)}
                                        {/* {notesGroup && notesGroup.hotel_prefs && notesGroup.hotel_prefs.note_json && notesGroup.hotel_prefs.note_json.blocks && notesGroup.hotel_prefs.note_json.blocks[0] && notesGroup.hotel_prefs.note_json.blocks[0].text ? notesGroup.hotel_prefs.note_json.blocks[0].text : ''} */}
                                    </div>
                                    {notesGroup && (
                                        <Form
                                            onSubmit={(values, form) => this.onSubmit(values, form)}
                                            initialValues={notesGroup.hotel_prefs}
                                            render={({ handleSubmit, pristine, invalid }) => (
                                                <form onSubmit={handleSubmit}>
                                                    <div className="container-fluid">
                                                        <div className="row">
                                                            <FormGroup>
                                                                <Field
                                                                    name="note_json"
                                                                    type="textarea"
                                                                    component={TextEditor}
                                                                    placeholder="Lodging requests for this group. This note will be included in all tour stops."
                                                                />
                                                            </FormGroup>
                                                            <Button bsStyle="success" type="submit" style={{ width: '16%', float: 'right' }}>
                                                                Save Notes
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </form>
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                            <br></br>
                        </div>
                    ))}
                </div>
                {this.state.showConfirmDialog && (<Modal show={this.state.showConfirmDialog} onHide={this.onClosebidpopup}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Group</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p> Are you sure want to delete group?</p>
                        <ButtonToolbar style={{ float: 'right' }}>
                            <Button
                                bsStyle="success"
                                onClick={this.removeGroupAction}
                            >
                                Confirm
                            </Button>
                            <Button
                                bsStyle="success"
                                onClick={this.onClosebidpopup}
                            >
                                Cancel
                            </Button>
                        </ButtonToolbar>
                    </Modal.Body>
                    <Modal.Footer style={{ clear: 'both' }} />
                </Modal>
                )}
                {this.state.bidSetflag && (
                    <Modal show={this.state.bidSetflag} onHide={this.onClosebidpopup}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Group Deletion</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <p> Deleting this group will also delete the bids sent for this group. Are you sure you want to delete it?</p>
                        <ButtonToolbar style={{ float: 'right' }}>
                            <Button
                                bsStyle="success"
                                onClick={this.removeConfirmBid}
                            >
                                Confirm
                            </Button>
                            <Button
                                bsStyle="success"
                                onClick={this.onClosebidpopup}
                            >
                                Cancel
                            </Button>
                        </ButtonToolbar>
                    </Modal.Body>
                    <Modal.Footer style={{ clear: 'both' }} />
                </Modal>
                )}
                {this.state.editTablepopup && (
                    <Modal show={this.state.editTablepopup} onHide={this.onClosebidpopup}>
                        <Modal.Header closeButton>
                            <Modal.Title>Edit Define Group</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <BootstrapTable
                                data={this.state.editdata}
                                striped
                                cellEdit={{
                                    mode: 'click',
                                    blurToSave: true,
                                    afterSaveCell: (oldValue, newValue, row, column) => this.handleCellEdit(row, column, newValue)
                                }}
                            >
                                <TableHeaderColumn dataField="id" width="100" hidden isKey>ID</TableHeaderColumn>
                                <TableHeaderColumn dataField="group_name" width="90" headerAlign="center" dataAlign="center" editable={{ type: 'text' }} >group name</TableHeaderColumn>
                            </BootstrapTable>
                            <br></br>
                            <div className="row">
                                <div className="col-md-12">
                                    <FormGroup>
                                        <ButtonToolbar>
                                            <Button bsStyle="success" onClick={this.sendEditGroup}>
                                                Save
                                            </Button>
                                            <Button bsStyle="success" onClick={this.onClosebidpopup}>
                                                Cancel
                                            </Button>
                                        </ButtonToolbar>
                                    </FormGroup>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer style={{ clear: 'both' }} />
                    </Modal>
                )}
                {this.state.uploadDocModel &&(
                    <UploadFormModal 
                    event_id={this.state.eventIds}
                    group_id={this.state.groupDocId}
                    tour={this.props.tour}
                    model_type={'Bid Docs'}
                    upload_type={'Bid Group'}
                    show={this.state.uploadDocModel}
                    onClose={this.closeModal}
                    />
                )}

            </div >
        );
    }
}
export default DefineGroupPopup


// WEBPACK FOOTER //
// src/routes/tours/components/DefineGroupPopUp.js